$(document).ready(function () {

	const BUHREPORT_AJAX_URL = '/local/ajax/personal.buhreport.php';


	let buhFilterForm = $('.buh-filter form');
	let buhPageNumber = buhFilterForm.find('input[name=page]');
	// let pageNumber = parseInt(buhPageNumber.val());
	// if (pageNumber !== 0) {
	// 	let url =`${location.pathname}?page=${pageNumber}`;
	// 	history.pushState({
	// 		url: url
	// 	}, '', url);
	// }


	$('.buh-select-by-page select').change(function () {
		buhFilterForm.find('input[name=itemsByPage]').val($(this).val());
		buhFilterForm.submit();
	});
	$('.buh-pages .pagination a').click(function (e) {
		e.preventDefault();
		let val = $(this).attr('href').replace('?page=', '');
		buhPageNumber.val(val);
		buhFilterForm.submit();
		// console.log(val);
	});
	$(document).on('click', '.buh-save', function (e) {
		e.preventDefault();

		let postData = {
			downloadFile: 'Y',
		};
		for (let item of $('.buh-filter form').serializeArray()) {
			// console.log(item);
			postData[item.name] = item.value;
		}
		// console.dir(postData);


		$.get(BUHREPORT_AJAX_URL, postData, ({FILE_URL = ''}) => {
			// console.dir(response);
			if (FILE_URL) {
				let link = document.createElement("a");
				link.setAttribute("href", FILE_URL);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				delete link;
			}
		}, 'json');

	});
	$(document).on('click', '.buh-table-sorter > div', function (e) {
		let field = $(this).closest('.buh-table-sorter').data('field');
		let asc = parseInt($(this).data('asc')) == 1;

		let sortBy = buhFilterForm.find('input[name=sortBy]');
		let sortAsc = buhFilterForm.find('input[name=sortAsc]');
		let initField = sortBy.val();
		let initAsc = parseInt(sortAsc.val()) == 1;
		// console.log(field, asc);
		// console.log(initField, initAsc);
		let doSort = false;
		if (initField !== field || initAsc !== asc) {
			sortBy.val(field);
			sortAsc.val(asc ? 1 : '');
			console.log(field, asc);
			// console.log('doSort')
			buhFilterForm.submit();
		}
	});
	// $(document).on('click', '.buh-get-link', function (e) {
	//     // e.preventDefault();
	// });

	function statisticsSubmit() {
		$('.buh-statistics-form').submit();
	}

	$(document).on('change', '.buh-statistics-form select[name=country]', function (e) {
		statisticsSubmit();
	});
	$(document).on('change', 'input[name^=date]', function (e) {
		if (!$(this).hasClass('js-not-submit'))
			statisticsSubmit();
	});

	const companyListContent = $('#buh-statistics-company');
	const companySearchTips = $('.buh-statistics-company-search-tips');
	$(document).on('keyup', '.buh-statistics-company-search', function () {
		console.clear();
		console.log('ajax search');
		let str = $(this).val();
		if (str.length >= 3) {
			$.get(BUHREPORT_AJAX_URL, {
				type: 'statistics',
				method: 'statisticsCompanySearch',
				dateStart: $('input[name=dateCompanyStart]').val(),
				dateEnd: $('input[name=dateCompanyEnd]').val(),
				search: str,
			}, ({COMPANY_LIST}) => {
				// console.dir(resp);
				// let COMPANY_LIST = Object.values(COMPANY_LIST);

				companySearchTips.empty();

				if (COMPANY_LIST.length) {
					COMPANY_LIST.map(item => {
						companySearchTips.append(`<li data-id="${item.ID}">${item.NAME}</li>`);// (${item.ID})
					});
					companySearchTips.show();
				}

			}, 'json');
		}
	});


	function companySelect(id, companyName) {
		$.get(BUHREPORT_AJAX_URL, {
			type: 'statistics',
			method: 'statisticsGetCompany',
			id: id,
			dateStart: $('input[name=dateCompanyStart]').val(),
			dateEnd: $('input[name=dateCompanyEnd]').val(),
		}, ({USERS}) => {
			console.log(companyName, USERS.length);

			let counter = 0;
			if (USERS.length)
				counter = `<a href="#" data-fancybox data-src="#statistics-company-users">${USERS.length}</a>`;

			companyListContent.html(`<tr>
            <td>${companyName}</td>
            <td>${counter}</td>
            </tr>`);
			companySearchTips.hide();

			if (USERS.length) {
				$('#statistics-company-users h2').html(companyName);
				let tblBody = $('#statistics-company-users tbody');
				tblBody.empty();
				USERS.map(user => {
					tblBody.append(`
                    <tr>
                        <td>${user.DATE_REGISTER}</td>
                        <td>${user.ID}</td>
                        <td>${user.NAME}</td>
                    </tr>
                    `);
				});
			}


		}, 'json');
	}

	let selectedCompanyId = 0;
	let selectedCompanyName = '';
	$(document).on('click', '.buh-statistics-company-search-tips li', function () {
		// console.log('ID=', $(this).data('id'), $(this).html());

		selectedCompanyId = $(this).data('id');
		selectedCompanyName = $(this).html();
		companySelect(
			selectedCompanyId,
			selectedCompanyName
		);
	});

	$(document).on('change', 'input[name=dateCompanyStart], input[name=dateCompanyEnd]', function () {
		// console.log('change dates', selectedCompanyId, selectedCompanyName)
		if (selectedCompanyId) {
			companySelect(
				selectedCompanyId,
				selectedCompanyName
			);
		}
	});


	if ($('.js-mask-date').length)
		$('.js-mask-date').mask("00.00.0000", {autoclear: true});
	// $(document).on('focus', '.js-mask-date', function(){
	// 	//Двигаем каретку в начало
	// });
	$(document).on('blur', '.js-mask-date', function(){
		if ($(this).val() == '')
			$(this).val($(this).data('default'));
	});
});
